export default __webpack_public_path__ + "static/media/RuralAids.f500151c.png";